@import '../../theme/global';

snap-checkbox-button {
  display: flex;
  justify-content: flex-start;
  position: relative;
  text-align: left;
  @include set-font;
  @include box-sizing;
  @include reset-inputs;

  p {
    margin: 0;
  }

  .input-wrapper {
    align-items: center;
    display: flex;
    height: 1.25rem;
    margin-right: 0.5rem;
    order: 0;
  }

  .label-wrapper {
    font-size: 0.875rem;
    line-height: 1.25rem;
    order: 1;

    &.right {
      order: initial;
    }
  }

  .label {
    color: $gray-700;
    font-weight: 500;
  }

  &.disabled:not(.selected) {
    .label {
      color: $gray-500;
    }

    .description {
      color: $gray-400;
    }
  }

  .input {
    appearance: none;
    background-origin: border-box;
    border-color: $gray-300;
    border-radius: 0.25rem;
    border-width: 1px;
    color: $blue-600;
    color-adjust: exact;
    display: inline-block;
    flex-shrink: 0;
    height: 1rem;
    padding: 0;
    -webkit-print-color-adjust: exact;
    user-select: none;
    vertical-align: middle;
    width: 1rem;

    --tw-shadow: 0 0 #0000;

    &:hover:not([disabled]) {
      border: 1px solid $blue-600;
      box-shadow: 0 0 0 1px $blue-600;
    }

    &.locked:checked {
      background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%2394A3B8' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
    }
  }

  .description {
    color: $gray-500;

    span {
      @include sr-only;
    }
  }

  & input[type='checkbox'][disabled] {
    background-color: $gray-100;
    border: 1px solid $gray-300;
    cursor: not-allowed;

    .label {
      color: $gray-500;
    }
  }

  &[checkbox-side='right'] {
    justify-content: space-between;
    width: 100%;

    .label-wrapper {
      margin-left: 0;
      margin-right: 0.75rem;
    }
  }

  [type='checkbox']:checked {
    background-color: $blue-600;
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
  }

  [type='checkbox']:focus-visible {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #3b82f6;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
